import axios from "axios";
import { getCurrentLocale } from "./index";
import { getLocaleInfo } from "../util/contentModelToData";
// import { match } from '@reach/router/lib/utils'

// if (typeof document === "undefined") {
//     require("dotenv").config();
// }

const locale = getCurrentLocale();
const { currency, language } = getLocaleInfo(locale);

const API_KEY = process.env.GATSBY_TRAVELIZE_API_KEY;
const URL = process.env.GATSBY_TRAVELIZE_URL;
const SLIM_URL = process.env.GATSBY_TRAVELIZE_SLIM_URL.replace('[COUNTRY]', language).replace('[CURRENCY]', currency);
const VALIDATE_URL = process.env.GATSBY_TRAVELIZE_VALIDATE_URL;
const SUBMIT_URL = process.env.GATSBY_TRAVELIZE_SUBMIT_URL;


const encodeBody = ({
                        productCode,
                        packageCode = "",
                        startDate,
                        endDate,
                    }) => {
    const params = [
        "product=" + productCode,
        "sitelanguage=" + language,
        "sitecurrency=" + currency,
    ];

    if (startDate) {
        if(typeof startDate.toISOString === 'function')
            params.push("startdate=" + startDate.toISOString().split("T")[0]);
        else
            params.push("startdate=" + startDate);
    }

    if (endDate) {
        params.push("enddate=" + endDate.toISOString().split("T")[0]);
    }

    if (packageCode) {
        params.push("packageCode=" + packageCode);
    }

    return params.join("&");
};

export const validateTravelizeData = (lang, options) => {
    let url = `${VALIDATE_URL}${lang}`;
    return axios({
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": API_KEY,
        },
        method: "post",
        data: options
    }).then(({ data }) => data);
};

export const submitTravelizeData = (lang, options) => {
    let url = `${SUBMIT_URL}${lang}`;

    return axios({
        url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": API_KEY
        },
        method: "post",
        data: options
    }).then(({ data }) => data);
};

const getTravelizeFeed = (url, options) => axios({
    url,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": API_KEY,
    },
    method: "post",
    data: encodeBody(options)
}).then(({ data }) => data);

const getTravelizeSlimFeed = () => {
    return axios.get(SLIM_URL).then((result) => {
        return result.data.sort((a, b) => b.priceFrom - a.priceFrom);
    });
};

const packageHasRoomAvailability = ( packageItem, options ) => {

    const checkRooms = ( packageItem, options ) => {
        const { duration, additions, minRoomSize } = options;
        const selectedAdditions = additions;

        const totalPax = selectedAdditions ? selectedAdditions.reduce((totalPax, selectedAddition) => {
            return totalPax + selectedAddition.quantity
        }, 0) : 0

        const totalRoomAllotment = packageItem.rooms ? packageItem.rooms.reduce((totalRoomAllotment, room) => {
            return totalRoomAllotment + room.nominalPax * room.roomsAvailable
        }, 0) : 0

        const matchTotalPaxWithRooms = !totalPax || (totalRoomAllotment >= totalPax)

        const matchRooms = !minRoomSize || minRoomSize === 1 ||
            packageItem.rooms.some(room => room.nominalPax >= minRoomSize && room.roomsAvailable > 0);

        return matchRooms && matchTotalPaxWithRooms;

    }

    return packageItem.hotelID === -1 ? true : checkRooms( packageItem, options )

}

// returns true if the package contains the selected additions in DurationActivitySelect
const packageContainsAdditions = ( packageItem, options ) => {

    const { additions } = options;
    const selectedAdditions = additions;
    const additionsInPackage = !!packageItem.additions ? packageItem.additions.map(({ additionDetails }) => additionDetails).flat() : [];

    const matchAdditions = !selectedAdditions || selectedAdditions.every(selectedAddition => {
        return additionsInPackage.some((additionInPackage) => {
            return additionInPackage.additionID === selectedAddition.additionID && selectedAddition.quantity <= additionInPackage.additionAllotment
        })
    });

    return matchAdditions;

}

// This funciton is ONLY called from DateSelect.js
export const getTravelizePackages = options => {
    
    return getTravelizeFeed(URL, options)
        .then(feed => typeof(feed.packageData) !== "undefined" ? feed.packageData.Packages : [])
        // filter : only keep packages that match the duration selected in DurationActivitySelect
        .then( packages => packages.filter( packageItem => !options.duration || packageItem.durationDays === options.duration ))
        // filter : only keep packages that contains the selected addition(s) in DurationActivitySelect
        .then( packages => packages.filter( packageItem => packageContainsAdditions( packageItem, options ) ))        
        // map : set package availability based on if there are enough beds/rooms
        .then( packages => {
            packages.map( packageItem => packageItem.avialability = packageHasRoomAvailability( packageItem, options ) )
            return packages
        })        

}

export const getTravelizePackage = (productCode, packageCode) => getTravelizePackages({ productCode, packageCode })
.then(result => result[0]);

export const getAvailableDurations = availableBookingTypes =>
    ([...new Set(availableBookingTypes.map(({ durationDays }) => durationDays))]);


export const getAvailableMandatoryAdditions = (availableBookingTypes, selectDurationDays, customSortOrder) => {
    const additions = {};
    let sortedAdditions = {};

    // get additions that match the selected number of duration days
    if(selectDurationDays && selectDurationDays.value) {
        availableBookingTypes.filter(({durationDays}) =>
          durationDays == selectDurationDays.value).forEach((bookingType) => {
            additions[bookingType.additionID] = bookingType;
        });
    }

    // if we don't have a custom sort order sort by price low to high
    if( !customSortOrder ) {        
        return Object.values(additions).sort((a, b) => a.priceFrom - b.priceFrom);   
    }

    // sort them based on custom sort order (or by price low to high if not all additions are set in the custom sort order)
    // i.e for the content type checkoutCustomOrderAdditions in contentful you can specify one additionID only and that will 
    // always be first and the rest will be sorted by price

    return Object.values( additions ).sort( (a,b) => {

        let iA = customSortOrder.additionIDs.indexOf( a.additionID.toString() );
        let iB = customSortOrder.additionIDs.indexOf( b.additionID.toString() );

        //console.log( 'iA:', iA, a.additionID.toString() )
        //console.log( 'iB:', iB, b.additionID.toString() )

        // sort by price when both a.additonID and b.additionID are not found in the custom sort order
        if( iA == -1 && iB == -1 ) {
            //console.log( 'Addition iA and iB not found. Return 0' )
            return a.priceFrom - b.priceFrom
        }

        // when a.additionID is found but not b.additionID a should be moved before b
        if( iA >= 0 && iB == -1 ) {
            //console.log( 'Addition iB not found. Return -1' )
            return -1
        }

        // when b.additionID is found but not a.additionID a should be moved after b
        if( iA == -1 && iB >= 0 ) {
            //console.log( 'Addition iA not found. Return 1' )
            return 1
        }

        // both additions found sort accordingly
        if( iA < iB ) {
            //console.log( 'Addition iA should be before iB. Return -1' )
            return -1;
        } else if( iA > iB ) {
            //console.log( 'Addition iA should be after iB. Return 1' )
            return 1;
        }

        return 0;
    })

};

export const getAvailableBookingTypes = (productCode) => {
    return getTravelizeSlimFeed().then(bookings => bookings.filter((booking) => booking.product === productCode));
};